"use client"

import { FacebookIcon, FacebookShareButton, LinkedinIcon, LinkedinShareButton, TwitterIcon, TwitterShareButton, WhatsappIcon, WhatsappShareButton } from "next-share";

export default function SocialMediaShare() {

  const isWindowDefined = typeof window !== "undefined" && window.location.href;

  return (
    <div className="flex gap-2">
      <FacebookShareButton
        url={isWindowDefined ? "https://bestboilerplatesevereverever.com" : ""}
        quote={"Checkout this boilerplate... This is literally the Best Boilerplate Ever Ever Ever!"}
        hashtag={"#boilerplate"}
      >
        <FacebookIcon size={32} round />
      </FacebookShareButton>
      <TwitterShareButton
        url={isWindowDefined ? "https://bestboilerplatesevereverever.com" : ""}
        title={"Checkout this boilerplate... This is the Best Boilerplate Ever Ever Ever!"}
      >
        <TwitterIcon size={32} round />
      </TwitterShareButton>
      <WhatsappShareButton
        url={isWindowDefined ? "https://bestboilerplatesevereverever.com" : ""}
        title={"Checkout this boilerplate... This is the Best Boilerplate Ever Ever Ever!"}
      >
        <WhatsappIcon size={32} round />
      </WhatsappShareButton>
      <LinkedinShareButton
        url={isWindowDefined ? "https://bestboilerplatesevereverever.com" : ""}
        title={"Checkout this boilerplate... This is the Best Boilerplate Ever Ever Ever!"}
      >
        <LinkedinIcon size={32} round />
      </LinkedinShareButton>
    </div>
  )
}
